import { Model as s } from "../../../../model.js";
class i extends s {
  constructor(t) {
    super(), this.settings = t.settings, this.text = t.text;
  }
}
export {
  i as KioskConfigurationInactiveModel
};
//# sourceMappingURL=kioskConfigurationInactive.model.js.map
